/**
 * IBAS Service
 * Business application service endpoints
 */
import { ibasClient } from "./client";

export const ibasService = {
  /**
   * Submit application form
   * @param {Object} data - Application form data
   */
  submitApplication(data) {
    return ibasClient.post("/application/submit", data);
  },

  /**
   * Verify mobile number
   * @param {Object} data - Mobile number data
   */
  verifyMobileNumber(data) {
    return ibasClient.post("/verify/mobile", data);
  },

  /**
   * Check application status
   * @param {string} referenceNumber - Application reference number
   */
  checkApplicationStatus(referenceNumber) {
    return ibasClient.get(`/application/status/${referenceNumber}`);
  },

  /**
   * Get application details
   * @param {string} referenceNumber - Application reference number
   */
  getApplicationDetails(referenceNumber) {
    return ibasClient.get(`/application/${referenceNumber}`);
  },
};

export default ibasService;
